import React, { useEffect } from "react";
import "styles/App.scss";
import { BrowserRouter } from "react-router-dom";
import AsyncImport from "app/components/helpers/asyncImport";
import ScrollToTop from "app/components/helpers/scrollRestoration";
import Router from "constants/routes";
import { loadReCaptcha } from 'react-recaptcha-google'
const { MainRouter } = Router;
// subcomponents
const Header = AsyncImport(() => import("app/components/ui/header"));
const Content = AsyncImport(() => import("app/components/ui/content"));
const Footer = AsyncImport(() => import("app/components/ui/footer"));
const ErrorBoundary = AsyncImport(() => import("app/components/helpers/errorBoundary"));

const isAdmin = true;
const App = () => {

  useEffect(() => {
    loadReCaptcha();
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        {!isAdmin ? <Header /> : null}
        <Content children={<MainRouter />} />
        {!isAdmin ? <Footer /> : null}
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
